<template>
  <div class="flex custom-background">
    <div class="permission-denied">

      <div v-if="!this.$store.state.user.showPermissionDeniedMessage" class="container landing-section">
        <h1 class="welcome-message">Welcome to Education Portal</h1>
        <p>
          Schools today face increasing demands on how best to allocate their limited resources, whilst delivering quality
          education to the community. Schools not only have to grapple with fee structures and how to finance the delivery
          and expansion of key programs, but also an increasing level of regulation for obtaining funding and finance. We
          understand these challenges and have a dedicated team to work with you to help achieve your objectives. Our aim
          is to help you to best allocate your resources to where they are most needed, while minimising the barriers to
          achieving your goals.
        </p>
        <p>Our Education portal will help you achieve the same</p>
        <hr />
        <div class="button-container">
          <va-button class="btn" @click="navigateToDashboard">Get started</va-button>
        </div>
      </div>
      <div v-if="this.$store.state.user.showPermissionDeniedMessage" class="container permission-denied-section">
        <img class="denied-img" src="../../assets/img/permission_denied.svg" alt="Permission Denied">
        <h1 class="warning-title">PERMISSION DENIED</h1>
        <div class="content-container">
          <p class="content">Sorry about that, but you don't have permission to access this page.</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapActions } from 'vuex';


export default {
  name: "permission-denied",
  components: {
  },
  data() {
    return {
      hasSpecialPermissions: false,
      hasPermissions: false
    }
  },
  computed: {
    ...mapState({
      selectedEntity: state => state.user.selectedEntity
    })
  },
  watch: {
  },
  methods: {
    ...mapActions({
      setShowPermissionDeniedMessage: 'user/setShowPermissionDeniedMessage'
    }),
    navigateToDashboard() {
      this.checkPermissions();
      this.$router.push({ name: "dashboard" });
    },
    checkPermissions() {
      const permissionListLength = JSON.parse(JSON.stringify(this.$store.state.user.permissionList)).length;
      const specialPerimssionListLength = JSON.parse(JSON.stringify(this.$store.state.user.specialPermissionList)).length;
      let permissions = [];
      // const permissions = Object.values(this.permissionList).concat(Object.values(this.specialPermissionList))
      if (specialPerimssionListLength === 0) {
        permissions = Object.values(this.$store.state.user.permissionList)[0];
      } else {(
        permissions = Object.values(this.$store.state.user.specialPermissionList)
      )}
      if (permissions.indexOf('view_dashboard') === -1) {
        this.setShowPermissionDeniedMessage(true)
      } else {

        this.setShowPermissionDeniedMessage(false)
      }
    }
  }
}
</script>
<style scoped>
.custom-background {
  background-image: url(/img/landing-page-eduport.png);
  background-size: 124%;
  background-position: center;
  position: absolute;
  height: 100vh;
  left: 287px;
  right: 0px;
  top: 65px;
  padding: 5rem
}

.permission-denied {
  text-align: center;
}

.permission-denied-section {
  background: transparent;
}

.welcome-message {
  color: white;
}

h1 {
  color: white;
}

p {
  color: white;
  padding: 10px;
  line-height: 1.2em;
}

.container {
  display: inline-block;
  width: 80%;
}

.denied-img {
  width: 30%;
  height: 30%;
}

.warning-title {
  margin-top: 2rem;
  font-size: xx-large;
}

.content-container {
  text-align: center;
}

.content {
  width: 30%;
  display: inline-block;
  font-size: large;
  margin-top: 2rem;
}

.button-container {
  margin-top: 2rem;
}
</style>
    
    